import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_X_API_KEY_CATEGORIES
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_CATEGORIES,
  headers: { ...header }
})